module.exports = __webpack_public_path__ + "static/media/shapoorji_pallonji_logo.0da331bf.svg";